import { AxiosResponse } from "axios";
import { isFunction } from "lodash";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { useChatApi } from "../useChatApi";

export function useChatConversationRemoveMembers(
  options?: UseMutationOptions<
    AxiosResponse<number>,
    unknown,
    [number, string, Array<number>]
  >
) {
  const api = useChatApi();
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options || {};
  return useMutation((vars) => api.removeConversationMembers(...vars), {
    onSuccess: async (data, vars, ctx) => {
      isFunction(onSuccess) && onSuccess(data, vars, ctx);
      await queryClient.invalidateQueries(["chat-conversations"]);
      await queryClient.invalidateQueries(["chat-conversations-members"]);
    },
    ...rest,
  });
}
